module.exports = __webpack_public_path__ + "static/media/instagram-dashboard.9380d41d.svg";